import { FunctionComponent, ReactNode } from 'react'
import ReactDOM from 'react-dom'
import { PlayerExtended } from './Player'

interface Props {
  playerInstance: PlayerExtended | null
  children?: ReactNode
}

const InjectedOverlays: FunctionComponent<Props> = ({
  playerInstance,
  children,
}) => {
  return (
    (playerInstance?.el() &&
      ReactDOM.createPortal(children, playerInstance.el())) ||
    null
  )
}

export default InjectedOverlays
